export default __webpack_public_path__ + "static/media/1 (13).a3fa642b.jpg";